import {
  FETCH_POSTRETURNS_BEGIN,
  FETCH_ASSETVALUATIONS_SUCCESS,
  FETCH_POSTRETURNS_FAILURE,
} from "../constants/postReturns";

const initialState = {
  assetValuationData: [],
  isLoading: false,
  error: "",
};

export const getPostReturnsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_POSTRETURNS_BEGIN: {
      return {
        ...initialState,
        isLoading: true,
        error: null,
      };
    }
    case FETCH_ASSETVALUATIONS_SUCCESS:
      return {
        ...initialState,
        isLoading: false,
        assetValuationData: payload.assetValuationData,
      };
    case FETCH_POSTRETURNS_FAILURE:
      return {
        ...initialState,
        error: payload.error,
        isLoading: true,
      };
    default:
      return state;
  }
};

export default getPostReturnsReducer;
